import type { PresetRange } from '../../lib/date-utils';
import { PresetButton } from './preset-button';

interface PresetSidebarProps {
  presetRanges: PresetRange[];
  selectedPreset: string | null;
  onPresetSelect: (presetId: string) => void;
}

/**
 * Plain overflow rather than a Radix `ScrollArea`: nesting an `overflow-x-auto`
 * row inside the area's viewport left two scroll containers and the wheel
 * reached neither, so the narrow-screen row could not be scrolled at all. One
 * container also means a real scrollbar, which is the only hint that the
 * presets continue past the edge. The column never overflows (seven presets fit
 * in 350px), so the desktop sidebar looks exactly as before.
 */
export function PresetSidebar({ presetRanges, selectedPreset, onPresetSelect }: PresetSidebarProps) {
  return (
    <div className="w-full overflow-x-auto border-b bg-muted/30 sm:h-[350px] sm:w-[180px] sm:overflow-x-visible sm:overflow-y-auto sm:border-b-0 sm:border-r">
      <div className="flex flex-row gap-2 p-2 sm:flex-col">
        {presetRanges.map((preset) => (
          <PresetButton
            key={preset.id}
            preset={preset}
            isSelected={selectedPreset === preset.id}
            onSelect={() => onPresetSelect(preset.id)}
          />
        ))}
      </div>
    </div>
  );
}
